module.exports = __webpack_public_path__ + "img/Sonda-hidro-and-nivel.8f9d9c31.svg";